import { useState } from "react"
import { Link } from "react-router-dom"
import styled from "styled-components"
import EventMyCompModal from "./EventMyCompModal"

const CompLink = styled(Link)`
  color: #44ACE1;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`

export default ({
  eventData,
}) => {
  const [isOpen, setIsOpen] = useState()

  return (
    <>
      <CompLink onClick={() => setIsOpen(true)}>
        Show my comp for this event
      </CompLink>

      {isOpen &&
        <EventMyCompModal eventData={eventData} onClose={() => setIsOpen(false)} />
      }
    </>
  )
}